import differenceInDays from 'date-fns/differenceInDays';
import differenceInMonths from 'date-fns/differenceInMonths';
import isWithinInterval from 'date-fns/isWithinInterval';
import addSeconds from 'date-fns/addSeconds';
import toDate from 'date-fns/toDate';
import format from 'date-fns/format';

import nlLocale from 'date-fns/locale/nl';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';

export function exifDateToDate(datestring) {
  if (!datestring) return null;

  const [d, t] = datestring.split(' ');
  const date = d.replace(/:/gi, '-') + ' ' + t;

  return toDate(date);
}

export function dateToExifDate(date) {
  if (!date) return null;
  return format(date, 'YYYY:MM:DD HH:mm:ss');
}

export function dateToWords(childBirthday, datestring) {
  if (!datestring) return '';

  const childBirthDate = toDate(childBirthday);
  const compareDate = exifDateToDate(datestring);
  compareDate.setHours(0);
  compareDate.setMinutes(0);
  compareDate.setSeconds(0);

  const daysDifference = differenceInDays(compareDate, childBirthDate);
  const monthsDifference = differenceInMonths(compareDate, childBirthDate);

  if (daysDifference > 365) {
    const year = Math.floor(monthsDifference / 12);
    const months = monthsDifference - year * 12;
    return (
      year +
      kroostApp.strings.year +
      ' ' +
      (months > 0 ? months + (months !== 1 ? ` ${kroostApp.strings.monthsPlural}` : kroostApp.strings.months) : '')
    );
  } else if (monthsDifference >= 3) {
    return monthsDifference + ' ' + (monthsDifference > 1 ? kroostApp.strings.monthsPlural : kroostApp.strings.months);
  } else if (daysDifference > 7) {
    const weeks = Math.floor(daysDifference / 7) + 1;
    return weeks + ' ' + (weeks > 1 ? kroostApp.strings.weekPlural : kroostApp.strings.week);
  } else if (daysDifference > -7 && daysDifference < 0) {
    return (
      '- ' + Math.abs(daysDifference) + ' ' + (daysDifference > 1 ? kroostApp.strings.days : kroostApp.strings.day)
    );
  } else if (daysDifference < 0) {
    const weeks = Math.floor(Math.abs(daysDifference) / 7) + 1;
    return '- ' + weeks + ' ' + (weeks > 1 ? kroostApp.strings.weekPlural : kroostApp.strings.week);
  } else if (daysDifference === 0) {
    return kroostApp.strings.birthday;
  }

  return daysDifference + 1 + ' ' + (daysDifference > 0 ? kroostApp.strings.days : kroostApp.strings.day);
}

export function exifDateInRange(childBirthday, datestring, rangeStart, rangeEnd) {
  const compareDate = exifDateToDate(datestring);
  const start = addSeconds(childBirthday, rangeStart);
  const end = addSeconds(childBirthday, rangeEnd);

  if (start < end) {
    return isWithinInterval(compareDate, { start, end });
  }

  return isWithinInterval(compareDate, { start: end, end: start });
}

export function formatBirthday(childBirthday, dateFormat) {
  const parsed = toDate(childBirthday);
  const languages = {
    nl: nlLocale,
    de: deLocale,
    en: enLocale,
  };

  return isNaN(parsed.getTime()) ? '' : format(parsed, dateFormat, { locale: languages[kroostApp.language] });
}



// WEBPACK FOOTER //
// ./app/helpers/time.js